$(document).ready(function(){
  
  $("form label").text(function () { 
 return $(this).text().replace("Main Stone Color", "Couleur");
 });
  
 $("form label").text(function () { 
 return $(this).text().replace("Metal Color", "Couleur");
 });
  
 $("form label").text(function () { 
 return $(this).text().replace("Metal color", "Couleur");
 });
  
 $("form label").text(function () { 
 return $(this).text().replace("Color", "Couleur");
 });
  
   $("form label").text(function () { 
 return $(this).text().replace("Shoe Size", "Pointure");
 });
  
    $("form label").text(function () { 
 return $(this).text().replace("Size (Inch)", "Taille");
 });
  
   $("form label").text(function () { 
 return $(this).text().replace("Ring Size", "Taille de Bague");
 });
  
 $("form label").text(function () { 
 return $(this).text().replace("Size", "Taille");
 });
  
 $("form label").text(function () { 
 return $(this).text().replace("Material", "Model");
 });
  
  $("form label").text(function () { 
 return $(this).text().replace("Length", "Longueur");
 });
  
  $("form label").text(function () { 
 return $(this).text().replace("Height", "Hauteur");
 });
  
});

